import React from 'react';
import { connect } from 'react-redux';
import { updateChips } from '../../actions/alert_actions';
import { bindActionCreators } from 'redux';
//import '../App.css';

const Materialize = window.Materialize;

class List extends React.Component {

  updateCustomList = (e) => {
    //get employee selected from list
    let employee = this.props.list.find(person => person.id === Number(e.currentTarget.id));
    //if employee has a number listed, check if employee has already been added
    if (employee.mobilePhone || employee.phone) {
      if (this.props.chips.find((chip) => chip.phone && chip.phone === employee.phone) || this.props.chips.find((chip) => chip.mobilePhone && chip.mobilePhone === employee.mobilePhone)) {
        //if already added, toast a message
        Materialize.toast('An employee with the same phone number has already been added.', 4000, 'rounded red');
      } else {
        //if not added, add employee to list
        this.props.updateChips(employee.FirstName, employee.LastName, employee.mobilePhone, employee.phone,employee.id);
      }
    } else {
      //if no number listed, toast message
      Materialize.toast('Employee does not have a phone number.', 4000, 'rounded red');
    }

  }

  renderList() {
    //render list of employees based on selected location and gang
    return this.props.list.map((emp,i) => {
      let phone = ""
      if (emp.mobilePhone) {
        phone = emp.mobilePhone
      } else {
        phone = emp.phone
      }
      return (
        <li key={emp.id} id={emp.id.toString()} className="collection-item avatar" onClick={(e) => this.updateCustomList(e)}>
          <i className="material-icons circle green">person</i>
          <span className="title">{emp.FirstName} {emp.LastName}</span>
          <p>{phone} <br/>
          {emp.location} - {Number(emp.location) === 71 ? "Kau" : "Keaau"}
          </p>
        </li>
      );
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <ul className="collapsible">
          <li className="active">
            <div className="collapsible-header">
              <i className="material-icons ">group</i>
              Employees ({this.props.list.length })
            </div>
            <ul className="collapsible-body collection emp-list-alert">
              {this.renderList()}
            </ul>
          </li>
        </ul>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    list: state.list.employees,
    chips: state.form.chips
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateChips
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/components/alert/list.js